<template>
  <div class="c-startpage-hero-template-mobile carousel hero-mobile option-line-bullets">
    <template v-if="entries?.length > 0">
      <NuxtCarousel v-bind="carouselConfig" class="hero-mobile-carousel">
        <NuxtSlide v-for="entry in entries" :key="entry.priority">
        <template v-if="entry.type == 'Primary' && entry.images.primary">
            <NuxtLink 
              v-if="entry.images.primary.mobile.alt != '' || entry.altText != ''"
              :to="entry.cta.url"
              :external="true"
              :aria-label="entry.images.primary.mobile.alt || entry.altText"
              class="mobile-entry w-full"
            >
              <div class="mobile-card">
                <img class="mobile-card-image" :src="entry.images.primary.mobile.url || entry.altText" :alt="entry.images.primary.mobile.alt || entry.altText">
              </div>
            </NuxtLink>
          </template>
          <template v-if="entry.type == 'Secondary' && entry.images.secondary">
            <div 
              class="mobile-entry w-full"
            >
              <div class="mobile-card">
                  <StartpageHeroElementTileDetailed 
                    :entry="
                      {
                        timedOffer: entry.timedOffer,
                        cta: entry.cta,
                        image: { 
                          url: entry.images.secondary.mobile.url, 
                          alt: entry.images.secondary.mobile.alt 
                        },
                        badges: entry.badges,
                        brandId: entry.brandId,
                        callout: entry.callout,
                        headline: entry.headline,
                        description: entry?.description,
                        priority: entry.priority,
                        type: entry.type,
                        altText: entry.altText as string,
                        headlineOrange: entry.headlineOrange as boolean,
                      }
                    " 
                  />
              </div>
            </div>
          </template>
        </NuxtSlide>
        <template #addons>
          <NuxtNavigation />
          <NuxtPagination />
        </template>
      </NuxtCarousel>
    </template>
    <template v-else>
      <div class="entry flex flex-col bg-white lg:h-[500px] rounded-3xl">
        <div
          class="gap-8 justify-start h-1/2 items-center w-full bg-center bg-no-repeat bg-cover"
        >
          <BasicSkeleton auto>
            <template #placeholder>
              <SkeletonElementImage class="w-full h-[225px] rounded-t-3xl" :img-style-classes="'w-full'" />
            </template>
          </BasicSkeleton>
        </div>
        <div
          class="flex flex-col justify-between gap-2 lg:gap-4 h-1/2 p-4 pt-2 w-full min-h-[250px]"
        >
          <BasicSkeleton auto>
            <template #placeholder>
              <div>
                <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
                <SkeletonElementTextLine :height="'2rem'" :width="'100%'"/>
              </div>
            </template>
          </BasicSkeleton>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup lang="ts">
import { useMutationObserver } from "@vueuse/core";
import type { SliderEntry } from '../SliderStructure';

defineProps<{
  entries: SliderEntry[];
}>();


const slider = useTemplateRef('slider');
const carouselConfig = {
  itemsToShow: 1,
  gap: 24,
  breakpointMode: 'carousel',
  wrapAround: true,
  paginateByItemsToShow: true,
  autoplay: 3500,
  pauseAutoplayOnHover: true,
} as const;
useMutationObserver(slider, (mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes') {
      setTabIndex(mutation.target, mutation.oldValue === 'true' ? 0 : -1);
    }
  }
}, {
  attributes: true,
  attributeFilter: ['aria-hidden'],
  attributeOldValue: true,
  subtree: true,
});

const setTabIndex = (element: Node, tabIndex: number): void => {
  (element as HTMLElement).tabIndex = tabIndex;
  const children = (element as Element).querySelectorAll('a');
  for (const child of children) {
    child.tabIndex = tabIndex;
  }
};
</script>

<style scoped lang="postcss">
.mobile-entry {
  @apply flex h-full;
}

.mobile-card {
  @apply relative h-full w-full flex-1 overflow-hidden rounded-2xl bg-white;
  min-height: 30rem;
}

.mobile-card-image {
  @apply absolute inset-0 block h-full w-full object-cover;
}

.hero-mobile-carousel :deep(.carousel__viewport) {
  @apply rounded-2xl;
}

.hero-mobile-carousel :deep(.carousel__slide) {
  align-items: stretch;
}

.mobile-card :deep(.entry) {
  height: 100%;
}
</style>
